import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { Download } from "lucide-react";
import { LogoMark } from "./Logo";

const drawEmblem = (ctx, cx, cy, r) => {
  ctx.save();
  ctx.fillStyle = "#0A0A0D";
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = "#D4AF37";
  ctx.lineWidth = r * 0.09;
  ctx.beginPath();
  ctx.arc(cx, cy, r * 0.82, 0, Math.PI * 2);
  ctx.stroke();
  ctx.lineWidth = r * 0.11;
  ctx.lineCap = "round";
  ctx.beginPath();
  ctx.arc(cx, cy, r * 0.42, Math.PI * 0.32, Math.PI * 1.68);
  ctx.stroke();
  ctx.strokeStyle = "#F3E5AB";
  ctx.beginPath();
  ctx.moveTo(cx - r * 0.08, cy);
  ctx.lineTo(cx + r * 0.1, cy + r * 0.16);
  ctx.lineTo(cx + r * 0.42, cy - r * 0.22);
  ctx.stroke();
  ctx.restore();
};

export default function QRShareCard() {
  const canvasRef = useRef(null);
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.origin);
  }, []);

  useEffect(() => {
    if (!canvasRef.current || !url) return;
    QRCode.toCanvas(canvasRef.current, url, {
      width: 480,
      margin: 2,
      errorCorrectionLevel: "H",
      color: { dark: "#0A0A0D", light: "#F7EFD4" },
    });
  }, [url]);

  const download = () => {
    const qr = canvasRef.current;
    if (!qr) return;
    const out = document.createElement("canvas");
    out.width = 1080;
    out.height = 1400;
    const ctx = out.getContext("2d");

    ctx.fillStyle = "#0A0A0D";
    ctx.fillRect(0, 0, 1080, 1400);
    ctx.strokeStyle = "rgba(212,175,55,0.6)";
    ctx.lineWidth = 4;
    ctx.strokeRect(36, 36, 1008, 1328);

    ctx.textAlign = "center";
    ctx.fillStyle = "#D4AF37";
    ctx.font = "700 64px Outfit, sans-serif";
    ctx.fillText("CREDNOVA", 540, 150);
    ctx.fillStyle = "#A1A1AA";
    ctx.font = "500 26px 'Plus Jakarta Sans', sans-serif";
    ctx.fillText("SERVICES PRIVATE LIMITED", 540, 196);

    ctx.fillStyle = "#F7EFD4";
    ctx.fillRect(190, 260, 700, 700);
    ctx.drawImage(qr, 190, 260, 700, 700);
    drawEmblem(ctx, 540, 610, 92);

    ctx.fillStyle = "#F4F4F6";
    ctx.font = "600 34px 'Plus Jakarta Sans', sans-serif";
    ctx.fillText("Scan to open the CREDNOVA app", 540, 1060);
    ctx.fillStyle = "#71717A";
    ctx.font = "400 24px 'Plus Jakarta Sans', sans-serif";
    ctx.fillText(url, 540, 1110);
    ctx.fillStyle = "#D4AF37";
    ctx.font = "500 22px 'Plus Jakarta Sans', sans-serif";
    ctx.fillText("Your Trusted Partner for Loan Assistance", 540, 1230);

    const a = document.createElement("a");
    a.href = out.toDataURL("image/png");
    a.download = "crednova-app-qr.png";
    a.click();
  };

  return (
    <div className="card-gold hover:!transform-none p-6 flex flex-col items-center text-center" data-testid="qr-share-card">
      <p className="caption-gold mb-4">Get the App</p>
      <div className="relative rounded-2xl p-3 border border-[rgba(212,175,55,0.3)]" style={{ background: "#F7EFD4" }}>
        <canvas ref={canvasRef} className="block w-[168px] h-[168px]" data-testid="qr-canvas" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="bg-[#0A0A0D] rounded-xl p-1.5 border border-[rgba(212,175,55,0.6)]">
            <LogoMark size={24} />
          </div>
        </div>
      </div>
      <p className="text-xs text-[#A1A1AA] mt-4 leading-relaxed">
        Scan with your phone camera to open CREDNOVA and add it to your home screen.
      </p>
      <button
        onClick={download}
        data-testid="qr-download-button"
        className="btn-outline-gold mt-4 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-xs"
      >
        <Download size={13} /> Download QR Card
      </button>
    </div>
  );
}
